<template>
  <div class="greenbg relative">
    <TopNav class="topright" mode="light" home="true" taller="0px"></TopNav>

    <!-- <div class="flex flex-col lg:flex-col p-8 max-w-6xl mx-auto">
      <div class="">
        <div class="mb-8 lg:ml-20 lg:mt-20 lg:mb-20">
          <div class="font-serif title mx-auto">
            <div class=" text-6xl font-black">
              Lab
            </div>
          </div>
        </div>
        <div class="mb-8 lg:ml-20 lg:mb-20">
          <div class="font-serif text-2xl lg:text-4xl  lg:mb-5 title mx-auto d-font-lovely">
            LET’S EXPLORE!
          </div>
          <div class="font-mono words lg:text-lg mx-auto">
            Join us in some of our immersive gallery experiences below. Have the freedom to be bold and creative during your discovery journey!
          </div>
        </div>

      </div>
    </div> -->

    <div class="studiolab">
      <JellyStudioLab></JellyStudioLab>
    </div>

    <div class="greenbg flex flex-col lg:flex-col p-8 max-w-6xl mx-auto">
      <div class="">

        <div class="mb-8 lg:ml-20 lg:mt-20 lg:mb-20">
          <div class="font-serif title mx-auto">
            <div class=" text-6xl font-black">
              Lab
            </div>
            <!-- <img src="../assets/about/aboutus.svg" class="lg:h-24" alt=""> -->
            <!-- <img class="mt-20" src="../assets/about/love.svg" alt=""> -->
          </div>
        </div>

        <div class="mb-8 lg:ml-20 lg:mb-20">
          <div class="font-serif text-2xl lg:text-4xl  lg:mb-5 title mx-auto d-font-lovely">
            LET’S EXPLORE!
          </div>
          <div class="font-mono words lg:text-lg mx-auto">
            Join us in some of our immersive gallery experiences below. Have the freedom to be bold and creative during your discovery journey!
          </div>
        </div>

        <div class="mb-8 lg:ml-20 lg:mb-20">
          <a href="/studio">
            <div class="font-serif text-2xl lg:text-4xl  lg:mb-5 title mx-auto">
              Jellyfish Playground - Ocean Motion
            </div>
            <div>
              <img class=" max-w-full" src="../assets/jellyfish-demos/jellyfish.png" alt="">
            </div>
          </a>
          <div class="font-mono words lg:text-lg mx-auto">
            Use your finger on your touch pad or touch screen to play with Mr Jellyfish. Try to interact with him and the ocean water - push, pull, drag him around. Observe what happen. No matter what motion that you do, Mr Jellyfish will bounce back to his original form. No doubt that he appears lonely in his underwater quest and he seems determined to make his way around the ocean despite the constant interaction or hmmm…..“a little playfulness disruption” from our guest’s finger motion.
            <br />
            <br />
Ocean water moves in all kind of way and Jellyfish are pelagic animals that live in the open seas from tropical to Artic waters. Although Jellyfish can propel themselves with rhythmic motions of their umbrella, they are basically at the mercy of the currents of the sea.
          </div>
        </div>

        <div class="mb-8 lg:ml-20 lg:mb-20">
          <a href="/emoji">
            <div class="font-serif  text-2xl lg:text-4xl  lg:mb-5 title mx-auto">
              Reflecting Identity - Your Name, Your Matrix
            </div>
            <div>
              <img class=" max-w-full" src="../assets/jellyfish-demos/your-emoji.png" alt="">
            </div>
          </a>
          <div class="font-mono words lg:text-lg mx-auto">
            To get the best immersive experience, please turn on your camera and input your name (Chinese Single Character or for English name, preferably a short letter initial). Move your head, wave your hand, and enjoy creating your own piece of art with your own identity - NAME! Feel free to switch your name around and play around with the effect.
            <br />
            <br />
You are who you are - your face are unique and be proud of your own identity. When we were born, our parents created a name for us. This is the name that represent us throughout the years. Our parents, relatives, friends and colleagues called us by this name. Our face transforms as we grow older, from baby, to our teenage years, adults and into our golden age, bringing along our life experiences and wisdoms that we learn. Have you ever seen how your name interact with your face to create your identity?
          </div>
        </div>

        <div class="mb-8 lg:ml-20 lg:mb-20">
          <a href="/mountain">
            <div class="font-serif  text-2xl lg:text-4xl  lg:mb-5 title mx-auto">
              Mountain
            </div>
            <div>
              <img class=" max-w-full" src="../assets/jellyfish-demos/mountain.png" alt="">
            </div>
          </a>
          <div class="font-mono words lg:text-lg mx-auto">
            Use voice to build mountain.
          </div>
        </div>

        <div class="mb-8 lg:ml-20 lg:mb-20">
          <a href="/jelly-hand">
            <div class="font-serif  text-2xl lg:text-4xl  lg:mb-5 title mx-auto">
              Your light in your PALM.
            </div>
            <div>
              <!-- <img class=" max-w-full" src="../assets/jellyfish-demos/mountain.png" alt=""> -->
            </div>
          </a>
          <!-- <div class="font-mono words lg:text-lg mx-auto">
            Use voice to build mountain.
          </div> -->
        </div>

      </div>

      <div class="hidden lg:block fixed msg">
        <img src="../assets/about/madeby.svg" alt="Made by Lok With Love">
      </div>

      <div class="hidden lg:flex fixed aboutus-mini justify-end">
        <!-- <img @click="$router.push('/')" class="ml-12 cursor-pointer" src="../assets/about/home-mini.svg" alt="Home"> -->
        <!-- <img @click="$router.push('/')" class="ml-12 cursor-pointer w-32" src="../assets/home/jelly-button-white.svg" alt="Home"> -->
        <!-- <img class="ml-12" src="../assets/about/dash-mini.svg" alt="Dash"> -->
        <!-- <img @click="$router.push('/about')" class="ml-12 cursor-pointer" src="../assets/about/aboutus-mini.svg" alt="Made by Lok With Love"> -->
      </div>

      <div class="hidden lg:flex fixed flex-col social-mini justify-end">
        <!-- <img class="mb-8 cursor-pointer" src="../assets/about/fb.svg" alt="Home">
        <img class="mb-8 cursor-pointer" src="../assets/about/twitter.svg" alt="Dash">
        <img class="mb-8 cursor-pointer" src="../assets/about/ig.svg" alt="Made by Lok With Love"> -->
      </div>

    </div>

    <div>

    </div>
  </div>
</template>

<script>
export default {
  components: {
    JellyStudioLab: require('./JellyStudioLabEmbed.vue').default,
    TopNav: require('../uis/TopNav.vue').default
  }
}
</script>

<style lang="postcss" scoped>
.full.nofull {
  height: unset;
}

.topright{
  position: absolute;
  top: 0px;
  right: 0px;
  z-index: 100;
  width: 100%;
}
.greenbg {
  color: white;
  background: linear-gradient(180deg, #2c4fb1, #0a1a47);
  background-attachment: fixed;
  min-height: 100%;
  height: 100%;
}

.title {
  color: #FFFFFF;
  letter-spacing: 0.46px;
  line-height: 38px;
}

.words {
  color: #FFFFFF;
  letter-spacing: 0;
  line-height: 30px;
}

.msg {
  bottom: 40px;
  left: 40px;
}

.aboutus-mini {
  bottom: 40px;
  right: 40px;
  width: 400px;
}

.social-mini {
  top: calc((100vh - 400px) / 2 - 100px);
  right: 40px;
  height: 400px;
}

.font-lovely {
  font-family: 'Lovelo', 'Avenir', Helvetica, Arial, sans-serif;
}

.studiolab {
  height: 100%;
}
</style>
